import keywordTrackerApi from '@/app/KeywordTracker/api/keywordTrackerApi';
import type { GenericBody } from '@/app/KeywordTracker/types/keywordTrackerApiTypes';

const rankHistoricalApi = keywordTrackerApi.injectEndpoints({
  endpoints: build => ({
    countRankHistorical: build.query<unknown, GenericBody>({
      query: body => ({
        url: '/keyword_tracker/v2/ranks/count_historical',
        method: 'POST',
        body
      })
    }),
    getRankHistorical: build.mutation<unknown, GenericBody>({
      query: body => ({
        url: '/keyword_tracker/v2/ranks/get_historical',
        method: 'POST',
        body
      })
    })
  })
});

export const { useCountRankHistoricalQuery, useGetRankHistoricalMutation } =
  rankHistoricalApi;
export default rankHistoricalApi;
